/**
 * F8: usePermissions hook — единая точка для гранулярных прав warehouse.
 *
 * Использование:
 *   const can = usePermissions();
 *   if (!can("kits.edit")) return null;  // спрятать кнопку
 *
 * Кеш на 5 минут — права меняются редко.
 */
import { useQuery } from "@tanstack/react-query";
import { fetchPermissions, type WarehousePermission } from "@/api/warehouse";


export function usePermissions(): (perm: WarehousePermission) => boolean {
  const q = useQuery({
    queryKey: ["warehouse-permissions"],
    queryFn: () => fetchPermissions(),
    staleTime: 5 * 60 * 1000,
  });
  return (perm: WarehousePermission) => {
    if (!q.data) return true;  // пока грузится — оптимистично разрешаем (UI не дёргается)
    if (q.data.all) return true;
    return q.data.perms.includes(perm);
  };
}
